"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const SingleSelectWrapper = styled_components_1.default.div `
  margin-top: 25px;
`;
const FieldValidationError = styled_components_1.default.div `
  color: #ff0000;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const SingleSelect = (props) => {
    const { fieldData, onChange } = props;
    const [selectedOption, setSelectedOption] = (0, react_1.useState)({});
    const [showDetailFormat, setShowDetailFormat] = (0, react_1.useState)(false);
    const { type, disabled } = fieldData;
    const handleSelect = selectedValue => {
        const newSelectedOption = fieldData.options.find(option => option.label === selectedValue);
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
            if (type === 'single_select_inline') {
                onChange(fieldData, newSelectedOption.label);
            }
        }
    };
    const renderSingleSelect = () => fieldData.options.map(option => (react_1.default.createElement(material_1.FormControlLabel, { value: option.label, control: react_1.default.createElement(material_1.Radio, { required: fieldData.mandatory }), label: option.label, checked: option.id === selectedOption.id, onClick: () => handleSelect(option.label) })));
    const handleDialogButtonClick = (action = '') => {
        if (action === 'confirm') {
            onChange(fieldData, selectedOption.label);
        }
        else {
            const previousSelectedOption = fieldData.options.find(option => option.label === props.fieldData.value);
            if (previousSelectedOption) {
                setSelectedOption(previousSelectedOption);
            }
        }
        setShowDetailFormat(false);
    };
    (0, react_1.useEffect)(() => {
        const defaultOption = props.fieldData.options.find(option => option.selected);
        if (defaultOption) {
            setSelectedOption(defaultOption);
        }
    }, [props.fieldData.options]);
    return (react_1.default.createElement(SingleSelectWrapper, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
        type === 'single_select_inline' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Box, null, fieldData.mandatory ? `${fieldData.label} *` : fieldData.label),
            react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.RadioGroup, null, renderSingleSelect())))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.List, null,
                    react_1.default.createElement(material_1.ListItem, { onClick: () => setShowDetailFormat(true), disablePadding: true },
                        react_1.default.createElement(material_1.ListItemButton, null,
                            react_1.default.createElement(material_1.ListItemText, { primary: fieldData.label, secondary: selectedOption.label }))))),
            react_1.default.createElement(material_1.Dialog, { open: showDetailFormat, TransitionComponent: Transition, keepMounted: true, onClose: () => handleDialogButtonClick(), "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, fieldData.label),
                react_1.default.createElement(material_1.DialogContent, null,
                    react_1.default.createElement(material_1.Box, null,
                        react_1.default.createElement(material_1.List, { sx: { minWidth: 200 } }, renderSingleSelect()))),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleDialogButtonClick();
                        } }, i18n_js_1.default.t('cancel')),
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleDialogButtonClick('confirm');
                        } }, i18n_js_1.default.t('ok')))))),
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(FieldValidationError, null, fieldData.errors ? fieldData.errors.map(error => react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error)) : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = SingleSelect;
